import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-selected3",
  "use": "icon-icon-selected3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-selected3\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 16h12a4 4 0 0 0 4-4V0H4a4 4 0 0 0-4 4v12z\" fill=\"currentColor\" /><path stroke=\"#FFF\" stroke-width=\"1.738\" d=\"M4.5 8.045 6.906 10.5l4.594-5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol